export const types = {
    SET_TRANSIT_INSIGHTS_FILTERS: 'SET_TRANSIT_INSIGHTS_FILTERS',
    SET_TRANSIT_INSIGHTS_ROUTE: 'SET_TRANSIT_INSIGHTS_ROUTE',
    SET_TRANSIT_INSIGHTS_DATE_RANGE: 'SET_TRANSIT_INSIGHTS_DATE_RANGE',
    SET_TRANSIT_INSIGHTS_SELECTED_METRICS: 'SET_TRANSIT_INSIGHTS_SELECTED_METRICS',
    RESET_TRANSIT_INSIGHTS_FILTERS: 'RESET_TRANSIT_INSIGHTS_FILTERS',
    SET_TRANSIT_INSIGHTS_METRICS_PERIOD: 'SET_TRANSIT_INSIGHTS_METRICS_PERIOD',
    SET_TRANSIT_INSIGHTS_DIRECTION: 'SET_TRANSIT_INSIGHTS_DIRECTION',
    SET_TRANSIT_INSIGHTS_CHART_DATA_SMOOTHING: 'SET_TRANSIT_INSIGHTS_CHART_DATA_SMOOTHING',
};
